import { useGetAgenciesQuery } from '@/modules/agencies/api/agenciesApi'
import { useAgencyForm } from '@/modules/agencies/hooks/useAgencyForm'
import { useAppRoute } from '@/hooks/useAppRoute'
import { getAuthErrorMessage } from '@/utils/getAuthErrorMessage'

export function useAgenciesPage() {
  const { data, isLoading, isError, error } = useGetAgenciesQuery()
  const { openCreate } = useAgencyForm()
  const { navigateToAgency } = useAppRoute()

  return {
    agencies: data ?? [],
    isLoading,
    isError,
    errorMessage: isError ? getAuthErrorMessage(error) : null,
    isEmpty: !isLoading && !isError && (data?.length ?? 0) === 0,
    openCreate,
    onSelectAgency: navigateToAgency,
  }
}
